module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar positions = [];\nif(model.dataJSON && utils.isArray(model.dataJSON)){\npositions = model.dataJSON;\n}\n%>\n<div>\n<%\nif(positions.length < 1){\n%><p class=\"emptyTableMessage\"><%= storage.__('order.properties.basket.empty') %></p><%\n} else {\n%>\n<table cellpadding=\"0\" cellspacing=\"0\">\n<thead>\n<tr>\n<td width=\"40px\"><%= storage.__('order.properties.basket.columns.pos') %></td>\n<td class=\"ellipsis\"><%= storage.__('order.properties.basket.columns.name') %></td>\n<td width=\"75px\"><%= storage.__('order.properties.basket.columns.img') %></td>\n<td width=\"45px\"><%= storage.__('order.properties.basket.columns.qty') %></td>\n<td width=\"45px\"><%= storage.__('order.properties.basket.columns.price') %></td>\n<td width=\"50px\"><%= storage.__('order.properties.basket.columns.pos_sum') %></td>\n<td width=\"60px\"><%= storage.__('order.properties.basket.columns.pos_vat') %></td>\n<td width=\"60px\"><%= storage.__('order.properties.basket.columns.vat') %></td>\n<td width=\"35px\"></td>\n</tr>\n</thead>\n<%\nvar productUrl = '';\nfor(var pos of positions){\nif(model.webUrlBase && String(pos.url || '').replace(/^\\/+/, '').replace(/\\/+$/, '')){\nproductUrl = `${model.webUrlBase}/${String(pos.url).replace(/^\\/+/, '')}`;\n} else {\nproductUrl = '';\n}\n%>\n<tbody>\n<tr data-row-id=\"<%= pos.id %>\">\n<td><%= pos.pos %></td>\n<td><%= pos.name %></td>\n<td class=\"img\"><img src=\"<%= pos.img %>\" alt=\"-\" title=\"<%= pos.info %>\" /></td>\n<td><%= utils.number.format(pos.qty * 1).formatted %></td>\n<td><%= utils.number.format(pos.price * 1, { suffix: ' €' }, 'float').formatted %></td>\n<td><%= utils.number.format(pos.pos_sum * 1, { suffix: ' €' }, 'float').formatted %></td>\n<td><%= utils.number.format(pos.pos_vat * 1, { suffix: ' €' }, 'float').formatted %></td>\n<td><%= utils.number.format(pos.vat * 100, { suffix: ' %' }, 'float').formatted %></td>\n<td class=\"actions\">\n<%\nif(productUrl){\n%><a class=\"showEdit_product\" title=\"Zur Produktverwaltung\"><i class=\"fi fi-cog\" /></a><%\n%><a target=\"_blank\" href=\"<%= productUrl %>\" title=\"Zum Produkt\"><i class=\"fi fi-open-routes\" /></a><%\n}\n%>\n</td>\n</tr>\n</tbody>\n<%\n}\n%>\n</table>\n<%\n}\n%>\n</div>"
  , __filename = "components/templates/ttgShop/orders/fields/basket.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var positions = [];
if(model.dataJSON && utils.isArray(model.dataJSON)){
positions = model.dataJSON;
}

    ; __line = 6
    ; __append("\n<div>\n")
    ; __line = 8
    ; 
if(positions.length < 1){

    ; __line = 10
    ; __append("<p class=\"emptyTableMessage\">")
    ; __append(escapeFn( storage.__('order.properties.basket.empty') ))
    ; __append("</p>")
    ; 
} else {

    ; __line = 12
    ; __append("\n<table cellpadding=\"0\" cellspacing=\"0\">\n<thead>\n<tr>\n<td width=\"40px\">")
    ; __line = 16
    ; __append(escapeFn( storage.__('order.properties.basket.columns.pos') ))
    ; __append("</td>\n<td class=\"ellipsis\">")
    ; __line = 17
    ; __append(escapeFn( storage.__('order.properties.basket.columns.name') ))
    ; __append("</td>\n<td width=\"75px\">")
    ; __line = 18
    ; __append(escapeFn( storage.__('order.properties.basket.columns.img') ))
    ; __append("</td>\n<td width=\"45px\">")
    ; __line = 19
    ; __append(escapeFn( storage.__('order.properties.basket.columns.qty') ))
    ; __append("</td>\n<td width=\"45px\">")
    ; __line = 20
    ; __append(escapeFn( storage.__('order.properties.basket.columns.price') ))
    ; __append("</td>\n<td width=\"50px\">")
    ; __line = 21
    ; __append(escapeFn( storage.__('order.properties.basket.columns.pos_sum') ))
    ; __append("</td>\n<td width=\"60px\">")
    ; __line = 22
    ; __append(escapeFn( storage.__('order.properties.basket.columns.pos_vat') ))
    ; __append("</td>\n<td width=\"60px\">")
    ; __line = 23
    ; __append(escapeFn( storage.__('order.properties.basket.columns.vat') ))
    ; __append("</td>\n<td width=\"35px\"></td>\n</tr>\n</thead>\n")
    ; __line = 27
    ; 
var productUrl = '';
for(var pos of positions){
if(model.webUrlBase && String(pos.url || '').replace(/^\/+/, '').replace(/\/+$/, '')){
productUrl = `${model.webUrlBase}/${String(pos.url).replace(/^\/+/, '')}`;
} else {
productUrl = '';
}

    ; __line = 35
    ; __append("\n<tbody>\n<tr data-row-id=\"")
    ; __line = 37
    ; __append(escapeFn( pos.id ))
    ; __append("\">\n<td>")
    ; __line = 38
    ; __append(escapeFn( pos.pos ))
    ; __append("</td>\n<td>")
    ; __line = 39
    ; __append(escapeFn( pos.name ))
    ; __append("</td>\n<td class=\"img\"><img src=\"")
    ; __line = 40
    ; __append(escapeFn( pos.img ))
    ; __append("\" alt=\"-\" title=\"")
    ; __append(escapeFn( pos.info ))
    ; __append("\" /></td>\n<td>")
    ; __line = 41
    ; __append(escapeFn( utils.number.format(pos.qty * 1).formatted ))
    ; __append("</td>\n<td>")
    ; __line = 42
    ; __append(escapeFn( utils.number.format(pos.price * 1, { suffix: ' €' }, 'float').formatted ))
    ; __append("</td>\n<td>")
    ; __line = 43
    ; __append(escapeFn( utils.number.format(pos.pos_sum * 1, { suffix: ' €' }, 'float').formatted ))
    ; __append("</td>\n<td>")
    ; __line = 44
    ; __append(escapeFn( utils.number.format(pos.pos_vat * 1, { suffix: ' €' }, 'float').formatted ))
    ; __append("</td>\n<td>")
    ; __line = 45
    ; __append(escapeFn( utils.number.format(pos.vat * 100, { suffix: ' %' }, 'float').formatted ))
    ; __append("</td>\n<td class=\"actions\">\n")
    ; __line = 47
    ; 
if(productUrl){

    ; __line = 49
    ; __append("<a class=\"showEdit_product\" title=\"Zur Produktverwaltung\"><i class=\"fi fi-cog\" /></a>")
    ; 

    ; __line = 50
    ; __append("<a target=\"_blank\" href=\"")
    ; __append(escapeFn( productUrl ))
    ; __append("\" title=\"Zum Produkt\"><i class=\"fi fi-open-routes\" /></a>")
    ; 
}

    ; __line = 52
    ; __append("\n</td>\n</tr>\n</tbody>\n")
    ; __line = 56
    ; 
}

    ; __line = 58
    ; __append("\n</table>\n")
    ; __line = 60
    ; 
}

    ; __line = 62
    ; __append("\n</div>")
    ; __line = 63
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/ttgShop/orders/fields/basket.ejs

}